import React, { Component } from 'react'
import injectSheet from 'react-jss'
import Color from 'color'
import { flexUtils, palette } from '../../Theme/Theme'
import { connect } from 'react-redux'
import * as Actions from '../../Actions/Actions'
// import ReactGA from 'react-ga'

class Unsubscribe extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false
        }
    }

    render () {
        const { classes } = this.props
        return (
            <div className={classes.Container}>
                <h1 className={classes.Title}>Are you sure?</h1>
                <div className={classes.ActionContainer}>
                    <button className={classes.CancelButton} onClick={this.onCancel}>Cancel</button>
                    <button className={classes.SubmitButton} onClick={this.onSubmit}>{this.state.loading ? <i className="fas fa-spinner fa-spin"/> : 'Unsubscribe'}</button>
                </div>
            </div>
        )
    }

    componentDidMount () {
        // ReactGA.pageview('/Home/Unsubscribe');
    }           

    onCancel = () => {
        this.props.history.push('/Home/AccountInfo')
    }

    onSubmit = () => {
        const { dispatch, history, user } = this.props
        this.setState({ loading: true })
        dispatch(Actions.unsubscribeUser(user.token, history))
    }
}

const styles = {
    ...flexUtils,
    Container: {
        composes: ['$FlexColumn', '$FlexCenter'],
        width: '100%',
        height: '100%'
    },
    Title: {
        color: palette.white,
        fontSize: '2.8rem',
        marginBottom: '1rem'
    },
    ActionContainer: {
        composes: ['$FlexRow', '$FlexCenter']
    },
    Button: {
        margin: '1rem',
        width: '10rem',
        height: '2.8rem',
        border: 'none',
        borderRadius: '5px',
        fontSize: '1.1rem',
        fontWeight: '600',
        transition: 'all .5s',
        '&:hover': {
            cursor: 'pointer'
        },
        '&:focus': {
            outline: 'none'
        }
    },
    CancelButton: {
        composes: '$Button',
        color: 'rgb(50, 50, 50)',
        '&:hover': {
            background: 'rgb(180, 180, 180)'
        }
    },
    SubmitButton: {
        composes: '$Button',
        background: palette.blue,
        color: palette.white,
        '&:hover': {
            background: `${Color(palette.blue).darken(0.2)}`
        }
    }
}

const mapStateToProps = state => {
    return {
        user: state.mainState.user
    }
}

export default connect(mapStateToProps)(injectSheet(styles)(Unsubscribe))


// WEBPACK FOOTER //
// ./src/js/Components/Home/Unsubscribe.jsx